module.exports = __webpack_public_path__ + "img/trade-img-5a.eaa8c2fd.png";